import styled from "styled-components";

export const Container = styled.div.attrs({})`
  border-radius: 12px;
  width: 307px;
  min-height: fit-content;
  height: 368px;
  overflow: hidden;
  position: relative;


  display: flex;
  flex-direction: column;
  justify-content: flex-end;
`;

export const BackgroundImage = styled.img.attrs({})`
  position: absolute;
  top: 0;
  left: 0;
  
  width: 100%;
  height: 50%;

  object-fit: cover;
  
  filter: blur(8px);
  z-index: 0;
`;

export const Image = styled.img.attrs({})`
  width: 307px;
  height: 50%;
  
  object-fit: contain;
  position: absolute;
  top: 0;
  left: 0;
`;

export const ContentContainer = styled.div.attrs({})`
  border-radius: 8px 8px 0 0;
  width: 100%;
  height: fit-content;
  position: absolute;
  background-color: white;
  bottom: 0;
`;

export const ContentInner = styled.div.attrs({})`
  width: 100%;
  height: 100%;

  display: flex;
  flex-direction: column;
  padding: 30px 15px 0px 15px;

  position: relative;
`;

export const PerfilImg = styled.img.attrs({})`
  width: 54px;
  height: 54px;
  object-fit: cover;
  border-radius: 50%;
  position: absolute;
  top: -27px;
  left: 23px;
`;

export const PostTitleContainer = styled.div.attrs({})`
  width: 100%;
  padding-left: 10px;
  padding-right: 10px;

  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
`;

export const PostTitle = styled.span.attrs({})`
  font-size: 16px;
  color: ${(p) => p.theme.palette.colors.blacked};
`;

export const Text = styled.span.attrs({})`
  font-size: 12px;
  font-weight: 500;
  color: ${(p) => p.theme.palette.colors.text};
`;

export const MetricsRow = styled.div.attrs({})`
  width: 100%;
  padding-left: 10px;
  padding-right: 10px;

  display: flex;
  flex-direction: row;
  align-items: center;

  margin-top: 20px;
`;

export const Metrics = styled.div.attrs({})`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 6px;

  font-size: 14px;
  font-weight: 500;
`;

export const Point = styled.div.attrs({})`
  width: 9px;
  height: 9px;
  border-radius: 50%;
  background: linear-gradient(
    90deg, 
    #AF00E3 0%, 
    #C800DE 22%, 
    #E600DA 54%, 
    #F800D7 81%, 
    #FF00D6 100%
  );

  font-size: 14px;
  font-weight: 500;
`;

export const MetricsCol = styled.div.attrs({})`
  width: 100%;

  display: flex;
  flex-direction: column;

  margin-top: 22px;
`;

export const MetricLine = styled.div.attrs({})`
  width: 100%;
  padding: 9px 14px;

  display: flex;
  flex-direction: row;
  justify-content: space-between;

  border-top: 1px solid ${(p) => p.theme.palette.colors.borderline};
`;

export const Icon = styled.img.attrs(({ src }) => ({
  src,
}))`
    width: 35px;
    margin-Left: -5px;
    position: absolute;
    top: 12px;
    right: 16px;
`;